import React, { Fragment } from 'react';
import {
    Paper,
    List, ListItem, ListItemText, ListItemIcon,
    Typography, Divider
} from '@mui/material';
import Icon from '@mdi/react'
import {
    mdiMapMarker, mdiFireplace, mdiCityVariant,
    mdiBarcode, mdiPentagon, mdiDomain,
    mdiRoadVariant,
} from '@mdi/js';

const AddressCard = ({ address, title }) => {
    return (
        <Paper>
            {
                address ?
                    <List dense>
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography variant="h6"><b>{title}</b></Typography>
                                }
                            />
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemIcon>
                                <Icon path={mdiMapMarker} size={1} color="DodgerBlue" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body1"><b>Address</b></Typography>
                                }
                                secondary={
                                    <Typography variant="body1" display="inline">{address.Combined}</Typography>
                                }
                            />
                        </ListItem>
                        {
                            address.Road && <ListItem>
                                <ListItemIcon>
                                    <Icon path={mdiRoadVariant} size={1} color="DodgerBlue" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="body1"><b>Road</b></Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1">{address.Road}</Typography>
                                    }
                                />
                            </ListItem>
                        }
                        {
                            address.Landmark && <ListItem>
                                <ListItemIcon>
                                    <Icon path={mdiFireplace} size={1} color="DodgerBlue" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="body1"><b>Landmark</b></Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1" display="inline">{address.Landmark}</Typography>
                                    }
                                />
                            </ListItem>
                        }
                        {
                            address.City && <ListItem>
                                <ListItemIcon>
                                    <Icon path={mdiCityVariant} size={1} color="DodgerBlue" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="body1"><b>City</b></Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1">{address.City}</Typography>
                                    }
                                />
                            </ListItem>

                        }
                        {
                            address.PIN && <ListItem>
                                <ListItemIcon>
                                    <Icon path={mdiBarcode} size={1} color="DodgerBlue" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="body1"><b>PIN</b></Typography>
                                    }
                                    secondary={
                                        <Typography variant="body1">{address.PIN}</Typography>
                                    }
                                />
                            </ListItem>
                        }
                        {
                            (address.Zone || address.Marker) && <Fragment>

                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography variant="h6"><b>My Places</b></Typography>
                                        }
                                    />
                                </ListItem>
                                <Divider />
                                {
                                    address.Zone && <ListItem>
                                        <ListItemIcon>
                                            <Icon path={mdiPentagon} size={1} color="DodgerBlue" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <Typography variant="body1"><b>Zone</b></Typography>
                                            }
                                            secondary={
                                                <Typography variant="body1">{address.Zone}</Typography>
                                            }
                                        />
                                    </ListItem>
                                }
                                {
                                    address.Marker && <ListItem>
                                        <ListItemIcon>
                                            <Icon path={mdiDomain} size={1} color="DodgerBlue" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <Typography variant="body1"><b>Marker</b></Typography>
                                            }
                                            secondary={
                                                <Typography variant="body1">{address.Marker}</Typography>
                                            }
                                        />
                                    </ListItem>

                                }
                            </Fragment>
                        }
                    </List>
                    :
                    <h2>Loading</h2>
            }
        </Paper>
    );
}

export default AddressCard;